import { FC } from 'react';
import { PageProps } from './Page.types';
import { BackIconStyled, BackUrlStyled, LinkStyled, PageStyled, PageTitleStyled } from './Page.styles';
import { Separator } from '@base-app';

const Page: FC<PageProps> = ({ backTitle, backUrl, children, hasSeparator, title }) => {
  return (
    <PageStyled>
      {backUrl !== undefined && (
        <BackUrlStyled>
          <LinkStyled data-testid="page-link-back" to={backUrl}>
            <BackIconStyled />
            {backTitle ?? ''}
          </LinkStyled>
        </BackUrlStyled>
      )}
      <PageTitleStyled role="page-title">{title}</PageTitleStyled>
      {hasSeparator === true && <Separator />}
      {children}
    </PageStyled>
  );
};

export default Page;
